<div class="row" [formGroup]="form">
  <div class="col-md-12 mb-3 mt-2">
    <i-title text="Notifications"></i-title>
  </div>
  <div class="col-md-12 mb-3">
    <label class="super-compos-label-input">{{ 'account.activeModifications' | translate }}</label>
    <p-inputSwitch formControlName="enabled"></p-inputSwitch>
  </div>
  @if (form.get('enabled').value === true) {
    <div class="col-md-6 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'days' | translate }}</label>
      <p-multiSelect
        [placeholder]="'account.selectWeekdays' | translate"
        formControlName="weekDays"
        [virtualScroll]="true"
        [filter]="true"
        virtualScrollItemSize="30"
        [options]="weeks"
        appendTo="body"
        selectedItemsLabel="{0} éléments sélectionnés"
        [emptyFilterMessage]="'noResultFound' | translate"
        [resetFilterOnHide]="true"></p-multiSelect>
    </div>
  }
  @if (form.get('enabled').value === true) {
    <div class="col-md-6 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'hours' | translate }}</label>
      <p-multiSelect
        [placeholder]="'account.selectHours' | translate"
        formControlName="hours"
        appendTo="body"
        [virtualScroll]="true"
        [filter]="true"
        virtualScrollItemSize="30"
        [options]="hours"
        appendTo="body"
        selectedItemsLabel="{0} éléments sélectionnés"
        [emptyFilterMessage]="'noResultFound' | translate"
        [resetFilterOnHide]="true"></p-multiSelect>
    </div>
  }
  @if (form.get('enabled').value === true) {
    <div class="col-md-12 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'account.mailCategory' | translate }}</label>
      <p-multiSelect
        [placeholder]="'account.selectCategories' | translate"
        formControlName="tags"
        appendTo="body"
        [virtualScroll]="true"
        [filter]="true"
        virtualScrollItemSize="30"
        [options]="tags | sort: 'label' : 'ASC'"
        appendTo="body"
        selectedItemsLabel="{0} éléments sélectionnés"
        [emptyFilterMessage]="'noResultFound' | translate"
        [resetFilterOnHide]="true"></p-multiSelect>
    </div>
  }
  <div class="col-md-12 mt-3 d-flex align-items-center justify-content-center">
    <i-button (click)="submitNotifications()" [text]="'account.saveData' | translate" styleClass="green"> </i-button>
    <i-button (click)="resetNotifications()" [text]="'account.resetData' | translate" styleClass="red ms-3"> </i-button>
  </div>
</div>
